import "./App.css";
import { HelmetProvider } from "react-helmet-async";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./context";
import Router from "./Router/Router";

// Create a QueryClient instance outside the component to prevent recreation
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App: React.FunctionComponent<{}> = (props) => {
  const location = useLocation();

  useEffect(() => {
    try {
      if (window.gtag) {
        window.gtag("config", "G-L9CXJZ2521", { page_path: location.pathname });
      }
    } catch (error) {
      // Silently handle tracking errors
      console.log("Tracking blocked by ad blocker");
    }
  }, [location]);

  return (
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <AuthProvider>
          <Router />
        </AuthProvider>
      </HelmetProvider>
    </QueryClientProvider>
  );
};

export default App;
